export const LOAD_API_DATA_SUCCESS = "LOAD_API_DATA_SUCCESS";
export const LOAD_API_DATA_ERROR = "LOAD_API_DATA_ERROR";
export const BEGIN_API_DATA_CALL = "BEGIN_API_DATA_CALL";
